import {
    ADD_LANGUAGE,
    EDIT_LANGUAGE,
    LIST_LANGUAGE,
    VIEW_LANGUAGE,
    DELETE_LANGUAGE,

    LANGUAGE_SUCCESS,
    LANGUAGE_ERROR,
  
  } from "./actionTypes"
  
  // add Language
  export const addLanguage = (data, history, callback) => {
    return {
      type: ADD_LANGUAGE,
      payload: { data, history, callback }
    }
  }
  
  // edit Language
  export const editLanguage = (data, id, callback) => {
    return {
      type: EDIT_LANGUAGE,
      payload: { data, id, callback },
    }
  }
  
  // list Language
  export const listLanguage = (data, callback) => {
    return {
      type: LIST_LANGUAGE,
      payload: { data, callback },
    }
  }
  
  // view Language
  export const viewLanguage = (data, history) => {
    return {
      type: VIEW_LANGUAGE,
      payload: { data, history },
    }
  }
  
  // delete Language
  export const deleteLanguage = (data, callback) => {
    return {
      type: DELETE_LANGUAGE,
      payload: { data, callback },
    }
  }
  
  
  export const languageSuccess = message => {
    return {
      type: LANGUAGE_SUCCESS,
      payload: message,
    }
  }
  
  export const languageError = message => {
    return {
      type: LANGUAGE_ERROR,
      payload: message,
    }
  }
  